import {
  BillingInfo,
  Subscription,
  AppliedCoupon,
} from "@core/store/account/account.model";
import { Action } from "@ngrx/store";
import { ActionTypes } from "@core/store/account/account.actions";

export interface State {
  billingInfo: BillingInfo;
  subscriptions: Subscription[];
  loading: boolean;
  appliedCoupon: null | AppliedCoupon;
}

export const initialState: State = {
  billingInfo: null,
  subscriptions: [],
  loading: false,
  appliedCoupon: null,
};

export function reducer(state: State = initialState, action: Action): State {
  switch (action.type) {
    case ActionTypes.LOAD:
    case ActionTypes.UPDATE_BILLING_INFO:
    case ActionTypes.CREATE_SUBSCRIPTION:
    case ActionTypes.CHANGE_SUBSCRIPTION:
    case ActionTypes.CANCEL_SUBSCRIPTION:
    case ActionTypes.REDEEM_COUPON:
      return Object.assign({}, state, { loading: true });

    case ActionTypes.LOAD_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        billingInfo: action.payload.billingInfo,
        subscriptions: action.payload.subscriptions,
        appliedCoupon: action.payload.appliedCoupon,
      });

    case ActionTypes.UPDATE_BILLING_INFO_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        billingInfo: action.payload,
      });

    case ActionTypes.CREATE_SUBSCRIPTION_SUCCESS:
      return Object.assign({}, state, {
        subscriptions: [...state.subscriptions, action.payload].sort(
          (s1, s2) => {
            return (
              new Date(s2.activatedAt).getTime() -
              new Date(s1.activatedAt).getTime()
            );
          },
        ),
        loading: false,
      });

    case ActionTypes.CHANGE_SUBSCRIPTION_SUCCESS:
      return Object.assign({}, state, {
        subscriptions: state.subscriptions.map((subscription) => {
          return subscription.uuid === action.payload.uuid
            ? Object.assign({}, subscription, action.payload)
            : subscription;
        }),
        loading: false,
      });

    case ActionTypes.CANCEL_SUBSCRIPTION_SUCCESS:
      return Object.assign({}, state, {
        subscriptions: state.subscriptions.map((subscription) => {
          return subscription.uuid === action.payload.uuid
            ? Object.assign({}, action.payload)
            : subscription;
        }),
        loading: false,
      });

    // TODO
    case ActionTypes.REDEEM_COUPON_SUCCESS:
      return Object.assign({}, state, { loading: false });

    case ActionTypes.LOAD_FAIL:
    case ActionTypes.UPDATE_BILLING_INFO_FAIL:
    case ActionTypes.CREATE_SUBSCRIPTION_FAIL:
    case ActionTypes.CHANGE_SUBSCRIPTION_FAIL:
    case ActionTypes.CANCEL_SUBSCRIPTION_FAIL:
    case ActionTypes.REDEEM_COUPON_FAIL:
      return Object.assign({}, state, { loading: false });
  }
}

export const getBillingInfo = (state: State) =>
  state ? state.billingInfo : null;
// TODO: sort subscriptions?
export const getSubscriptions = (state: State) =>
  state ? state.subscriptions : [];
export const getAppliedCoupon = (state: State) =>
  state ? state.appliedCoupon : null;
export const isLoading = (state: State) => (state ? state.loading : false);



// WEBPACK FOOTER //
// /app/src/app/core/store/account/account.reducer.ts